export default __webpack_public_path__ + "static/media/f-10.0e194487.jpg";